import { Component, Input, OnInit, } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UtilService } from 'src/app/shared/services/api-services/util.service';




@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss'],
   
})
export class CountryComponent implements OnInit {
 
  @Input() parent;
  @Input() countryConfig;
  @Input() formControlName;
  @Input() controlName:string;
  @Input() countriesList;
  protected countryName: string = '';

  

  constructor(private utilService: UtilService) {
  }

  ngOnInit() {
 //   this.getCountriesList();
    if(this.parent.get([this.controlName]) && this.countriesList && this.countriesList.length > 0){
      this.countryName = this.parent.get([this.controlName]).value;
    }
    else{
      this.countryName = "";
    }
     
  }
 

  getCountryCode(value) {
    this.countryName = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryNameValue = this.countriesList.filter(val => val['description'] == value);
      this.countryName = (countryNameValue && countryNameValue[0] && countryNameValue[0]['description']) ? countryNameValue[0]['description'] : '';
      this.parent.get('countryCode').setValue(this.countryName)
    }
    return this.countryName;
  }
   

}
